import { atom } from 'jotai';

import {
  type Listing,
  type ListingGeoLocation,
} from '@/features/listing/types/listing-types';

interface ListingMapHighlight {
  coordinates: ListingGeoLocation;
  id: Listing['id'];
}

// eslint-disable-next-line import/prefer-default-export
export const listingMapHighlightAtom = atom<ListingMapHighlight | null>(null);
